import React, { useEffect, useState, useRef  } from 'react';

import TestStatusPopUpView from './view';

import * as UsersServices from '@services/Users';
import * as TestServices from '@services/Tests';
import { decryptText } from '@library/enc-dec';
import Swal from 'sweetalert2';

function TestStatusPopUp(props) {
	const[allTests, setAllTests]=useState([]);
	const[selectedTest, setSelectedTest]=useState('');
	const [newTestStatus, setNewTestStatus] = useState(null);
	const [disableSaveBtn, setDisableSaveBtn] = useState(true);
	const [inputPercentage, setInputPercentage] = useState('');
	const [showResultCheckBox, setShowResultCheckBox] = useState(false);
	
	useEffect(() => {
		getAllTests()
	}, []);
	
	const getAllTests = async()=>{
		try{
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			const payload={
				pageNo: 0,
				limit: 10000
			}
			const response = await TestServices.getAllTestQuestionBanks(payload, authToken);
			setAllTests(response.data)		
		}
		catch(err){
          console.log("Error coming while getting tests", err)
		}
	}

	const handleTestStatusRadioBtns = (event, value) => {
		setNewTestStatus(value);
		setDisableSaveBtn(false);
	};

	// To close the Test status popup container
	const handleCancelBtn = () => {
			setInputPercentage('');
			setNewTestStatus(null);
			setShowResultCheckBox(false);		
			setDisableSaveBtn(true);
			props.handleCancel() 
	};

	// Handle test status save button
	const handleSaveBtn = async () => {		
		let authToken = decryptText(localStorage.getItem('aEmediat'));
		let payload = {
			testExamIds:[selectedTest],
			userIds: props.userIds,
			examStatus: newTestStatus,
			percentage: inputPercentage
		};

		const response = await UsersServices.updateTestExamStatusForUser(payload, authToken);
		
		if(response.success)
		{
			Swal.fire({icon: "success",title: `Test status updated`,showConfirmButton: false,timer: 2500});	
			
			handleCancelBtn();
			props.handleSave();	
		}
		else{
			Swal.fire({icon: "error",title: response.message,showConfirmButton: false,timer: 2500});
		}
	};

	return (
		<TestStatusPopUpView
				allTests={allTests}
				handleSelectedTest ={setSelectedTest}
				props = {props} 
				newTestStatus = {newTestStatus}
				disableSaveBtn = {disableSaveBtn}
				handleTestStatusRadioBtns = {handleTestStatusRadioBtns}
				inputPercentage = {inputPercentage}
				handleInputPercentage = {setInputPercentage}
				showResultCheckBox = {showResultCheckBox}
				handleShowResultCheckBox = {setShowResultCheckBox}
				handleCancelBtn = {handleCancelBtn}
				handleSaveBtn  = {handleSaveBtn}
			/>
	);
}

export default TestStatusPopUp;
